import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["withHeader", "rows"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Scroll } from '@snack-uikit/scroll';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Table(_ref) {
  var _ref$withHeader = _ref.withHeader,
    withHeader = _ref$withHeader === void 0 ? true : _ref$withHeader,
    rows = _ref.rows,
    rest = _objectWithoutProperties(_ref, _excluded);
  var header = withHeader ? rows[0] : undefined;
  var body = withHeader ? rows.slice(1) : rows;
  return /*#__PURE__*/_jsx(Scroll, {
    barHideStrategy: "never",
    children: /*#__PURE__*/_jsxs("table", _objectSpread(_objectSpread({
      className: styles.table
    }, extractSupportProps(rest)), {}, {
      children: [header && /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsx("tr", {
          className: cn(styles.row, styles.rowHeader),
          children: header.map(function (_ref2, index) {
            var id = _ref2.id,
              content = _ref2.content,
              colSpan = _ref2.colSpan,
              rowSpan = _ref2.rowSpan,
              className = _ref2.className;
            return /*#__PURE__*/_jsx("td", {
              className: cn(styles.cell, styles.cellHeader, className),
              colSpan: colSpan,
              rowSpan: rowSpan,
              children: /*#__PURE__*/_jsx(RichText, {
                richText: content
              })
            }, id !== null && id !== void 0 ? id : index);
          })
        })
      }), body && /*#__PURE__*/_jsx("tbody", {
        children: body.map(function (row, index) {
          return /*#__PURE__*/_jsx("tr", {
            className: cn(styles.row, styles.rowBody),
            children: row.map(function (_ref3, index) {
              var id = _ref3.id,
                content = _ref3.content,
                rowSpan = _ref3.rowSpan,
                colSpan = _ref3.colSpan,
                className = _ref3.className;
              return /*#__PURE__*/_jsx("td", {
                className: cn(styles.cell, styles.cellBody, className),
                rowSpan: rowSpan,
                colSpan: colSpan,
                children: /*#__PURE__*/_jsx(RichText, {
                  richText: content
                })
              }, id !== null && id !== void 0 ? id : index);
            })
          }, index);
        })
      })]
    }))
  });
}